import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, endpoints } from "@/lib/api";
import { PageHeader } from "@/components/ui-blocks/PageHeader";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { MapPin, Users } from "lucide-react";
import { WhatsAppShare } from "@/components/WhatsAppShare";

export default function CampaignsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(endpoints.campaigns).then(setItems).catch(() => {}); }, []);
  return (
    <main>
      <PageHeader eyebrow="Campaigns" title="Active and upcoming CAF campaigns." lead="Every campaign is tagged, tracked and audited." />
      <section className="container-wide py-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {items.map((c) => {
          const pct = Math.min(100, Math.round(((c.raised_inr || 0) / (c.goal_inr || 1)) * 100));
          return (
            <div key={c.id} className="rounded-xl border border-[hsl(var(--border))] overflow-hidden bg-card card-lift" data-testid={`campaign-list-card-${c.slug}`}>
              <div className="aspect-[16/9] overflow-hidden"><img src={c.image} alt={c.title} className="h-full w-full object-cover" /></div>
              <div className="p-5">
                <div className="flex items-center gap-2"><Badge className="badge-orange border">{c.category}</Badge>{c.status === "active" ? <Badge className="badge-green border">Active</Badge> : <Badge className="badge-navy border">Upcoming</Badge>}</div>
                <h3 className="heading-3 mt-2 text-lg">{c.title}</h3>
                <p className="text-sm text-[hsl(var(--muted-ink))] mt-2 line-clamp-3">{c.summary}</p>
                <div className="mt-3 flex items-center gap-4 text-xs text-[hsl(var(--muted-ink))]"><span className="inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {c.location}</span><span className="inline-flex items-center gap-1"><Users className="h-3.5 w-3.5" /> {Number(c.beneficiaries).toLocaleString("en-IN")}</span></div>
                <div className="mt-3"><Progress value={pct} className="h-2" /><div className="mt-1.5 text-xs text-[hsl(var(--muted-ink))]">₹{Number(c.raised_inr).toLocaleString("en-IN")} of ₹{Number(c.goal_inr).toLocaleString("en-IN")} ({pct}%)</div></div>
                <div className="mt-4 flex items-center gap-2"><Link to="/donate"><Button size="sm" className="bg-[hsl(var(--navy))] hover:bg-[hsl(var(--navy-2))] text-background">Support</Button></Link><WhatsAppShare compact title={c.title} path={`/campaigns/${c.slug}`} /></div>
              </div>
            </div>
          );
        })}
      </section>
    </main>
  );
}
